import { showSuccess } from '@calendly/alert'
import { I18n } from '@calendly/i18n'

import { rootApi } from 'root-api'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['REPORTING_CONFIG', 'REPORTING'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchReportingConfiguration: build.query({
      query: ({ organization }) => ({
        url: '/api/reports/configuration',
        params: { organization },
        validateStatus: (response) => (response === 204 || response === 200)
      }),
      providesTags: ['REPORTING_CONFIG']
    }),
    saveReportingConfiguration: build.mutation({
      query: ({ organization, ...options }) => ({
        url: '/api/reports/configuration',
        method: 'POST',
        data: { organization, options: { ...options } },
      }),
      async onQueryStarted({ organization, ...options }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          api.util.updateQueryData('fetchReportingConfiguration', { organization }, (draft) => {
            (typeof draft === 'object' ? draft : {}).options = options
          })
        )
        try {
          await queryFulfilled
          dispatch(showSuccess(I18n.t('publisher.flash.changes_saved')))
        } catch {
          patchResult.undo()
        }
      },
      invalidatesTags: ['REPORTING_CONFIG'],
    }),
  })
})

export const {
  useFetchReportingConfigurationQuery,
  useSaveReportingConfigurationMutation,
} = api
